import React from "react";
import { Box } from "@mui/material";
import CardPatment from "./CardPayment";

const ListPayments = ({ listPayment = [] }) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 3,
        alignItems: "center",
      }}
    >
      {listPayment &&
        listPayment.map((paymeent) => (
          <CardPatment key={paymeent?._id} payment={paymeent} />
        ))}
    </Box>
  );
};

export default ListPayments;
